import React from "react";
import OrderTaskForm from "./OrderTaskForm";

const SOLICITUD = {
  title: "Solicitud",
  fields: [
    ["cliente_nombre", "Cliente"],
    ["empresa", "Empresa"],
    ["cliente_telefono", "Teléfono"],
    ["cliente_email", "Email"],
    ["items", "Productos solicitados"],
    ["notas", "Notas"],
  ],
};
const COTIZACION = {
  title: "Cotización",
  fields: [
    ["monto_cotizado", "Monto cotizado"],
    ["validez_dias", "Validez (días)"],
    ["condiciones", "Condiciones"],
  ],
};
const STAGES = ["Solicitud", "Cotización", "Respuesta"];
// Tarea «Enviar cotización al cliente» (actor VENTAS) — FORMCODE ELCOT3
const CONFIG = {
  stage: 1,
  stages: STAGES,
  title: "Enviar cotización al cliente",
  intro: "Envía la cotización por el medio acordado (correo o WhatsApp) y confirma aquí.",
  sections: ["custom"],
  customSections: [SOLICITUD, COTIZACION],
  noteLabel: "Nota del envío",
  optionHints: {
    "Enviada al cliente": "Pasa a Respuesta del cliente.",
    "Volver a preparar": "Regresa a Preparar cotización para ajustarla.",
  },
};

export default function ElevaxEnviarCotizacion(props) {
  return <OrderTaskForm {...props} config={CONFIG} />;
}
